import React, {Component} from 'react';
import {Modal, Timeline, Button, Row, Col} from 'antd';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getTasklogs, getTasklogByIndex} from './actions';
import Diff from './diff';

let newData = '';

class TaskTimeLineComponent extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            visible: false, // 弹框
            lastIndex: 0,
        };
    }

    componentDidMount() {

    }

    async showDetailModal(item) {
        newData = item.content;
        if (item.index > 1) {
            let data = {index: item.index - 1, taskId: item.taskId};
            await this.props.getTasklogByIndex(data);
        }
        this.setState({
            visible: true,
            lastIndex: item.index,
        });
    }

    renderDetail = data => {
        const _data = JSON.parse(data);
        // console.log('对比的',_data);时间段：${_data.timePairs[0].beginTime}~${_data.timePairs[0].endTime}
        let dom = ` 订单名称：${_data.taskDescription}
                    任务名称：${_data.taskName}
                    任务类型：${_data.taskType}
                    安卓ios分离： ${_data.iosAndroidIPSame}
                    APP唤醒方式：${_data.appWake || ''}
                    成功判定标准: ${_data.succStandard}
                    指定设备号前缀：${_data.deviceRedisKeyPreFix || ''}
                    UA标识：${_data.uaFlag || ''}
                    iOS设备库ID：${_data.iosUaPathId || ''}
                    Android设备库ID：${_data.androidUaPathId || ''}
                    苹果UA分布：${_data.iosUaVersion || ''}
                    安卓UA分布：${_data.androidUaVersion || ''}
                    任务来源：${_data.taskSource}
                    兴趣：${_data.interest}
                    用户信息：${_data.userInfo}
                    线索信息：${_data.clue}
                    app包名： ${_data.packageName}
                    留存比例：${_data.retainRatio}
                    账号信息：${_data.accountKey}
                    设备Id利用次数：${_data.deviceIdReusedTimes}
                    设备Id利用次数限制范围：${_data.deviceIdDiffByTaskOrEid}
                    是否打码：${_data.needHitCode == 0 ? '否' : '是'}
                    是否接码：${_data.needReceiveCode == 0 ? '否' : '是'}
                    代理模式: ${_data.proxyModel == undefined ? '' : (_data.proxyModel == 0 ? 'VPN' : 'SYSPOXY')}
                    外部任务分类： ${_data.outType}
                    API：${_data.api}
                    点击回传：${_data.isClickPassBack}
                    曝光回传：${_data.isEvPassBack}
                    是否串行：${_data.isBunchExecute}
                    是否首条先执行：${_data.isFirstExecute == 1 ? '是' : '否'}
                    素材是否使用真实ip: ${_data.isApiMaterialUseRealIp == 1 ? '是' : '否'}
                    API时间间隔: ${_data.evClickIntervalTime}
                    设备类型：${_data.deviceInfo}
                    安卓占比：${_data.androidRatio}
                    平台：${_data.platform}
                    曲线基准：${_data.curve}
                    结束方式: ${_data.endType}
                    url：${_data.url}
                    强制到达：${_data.forceArrive}
                    是否S2S：${_data.isS2S}
                    指定代理商：${_data.appointProxyName}
                    排除代理商：${_data.excludeProxyName}
                    独享代理池：${_data.exclusiveProxy}
                    总量控制：${_data.tc == 0 ? '是' : '否'}
                    忽略阻塞限制：${_data.ignoreThreshold == 0 ? '关闭' : '开启'}
                    分配方式：${_data.onTargetPv == 0 ? '余量分配' : '总量分配'}
                    禁用图片：${_data.disableImg == 0 ? '关闭' : '开启'}
                    是否追投: ${_data.isAdditional}
                    是否重写Canvas: ${_data.isOverwriteCanvas}
                    目标量：${_data.targetPv}
                    溢出量：${_data.overflow}
                    自定义溢出比例：${_data.overflowRate}
                    期望溢出：${_data.expectOverFlow}
                    溢出标准值：${_data.standardOverflowRate}
                    下浮值：${_data.reduceFlowRate}
                    上浮值：${_data.addFlowRate}
                    ivt阈值：${_data.ivt}
                    ivt控制范围：${_data.realTimeIvt}
                    启用截图：${_data.screenshots == 0 ? '关闭' : '开启'}
                    省份：${_data.provinces}
                    所属集群：${_data.belongCluster}
                    启用时间：${_data.filtration}
                    时间段：${JSON.stringify(_data.timePairs)}
                    PV频次及占比：${JSON.stringify(_data.pvDistributeEntities)}
                    等待时长(S)：${_data.waitTimeout}
                    是否是外部任务：${_data.isOutAd}
                    代理有效时长：${_data.forceWait}
                    UV占比：${_data.pvToUvRatio}
                    利用次数：${_data.ipReusedTimes}
                    利用次数限制范围：${_data.ipDiffByTaskOrEid}
                    ip使用范围：${_data.ipRange}
                    ip利用次数单位时间：${_data.ipInterval}
                    单位时间ip利用次数：${_data.ipUnitReuseTimes}
                    引擎：${_data.engine}
                    主脚本地址：${_data.mainScriptPath}
                    脚本地址：${_data.scriptPath}
                    客户端分组id：${_data.groupId || ''}
                    异步请求：${_data.isAsynRequest == 1 ? '是' : '否'}
                    强制互动：${_data.forceInteraction == 0 ? '关闭' : '开启'}
                    检测公司预警： ${(_data.interactionAlarm == 0 || _data.interactionAlarm == undefined) ? '关闭' : '开启'}
                    自动修改溢出： ${(_data.autoUpdateOverFlowRate == 0 || _data.autoUpdateOverFlowRate == undefined) ? '关闭' : '开启'}
                    执行脚本：${_data.executeScript}
                    脚本互动比例：${_data.shellProportion}
                    referer：${_data.referer}
                    完成标记：${_data.finishedFlag}
                    请求类型：${_data.requestType}
                    行为数据：${_data.behaviourData}
                    行为互动比例：${_data.activeProportion}
                    互动执行延时：${_data.behaviourDataWaitTime}
                    监测代码请求期望数：${_data.irCountExcept || 0}
                    关联taskId：${_data.connectTaskIds}
                    执行速度系数: ${_data.speedRatio}
                    追踪取样比例: ${_data.trackingSamplingRatio}
                    取样结束时间: ${_data.trackingFinishTime !== null && _data.trackingFinishTime !== undefined ? (new Date(parseInt(_data.trackingFinishTime)).toLocaleString().replace(/:\d{1,2}$/, ' ')) : ''}
                    点击率：${_data.clickRate}
                    点击率分组：${_data.clickRateFlag}
                    任务关联关键字：${_data.connectKey}
                    到达率：${_data.hzArrivalRate}
                    附加信息：${_data.dependentType}
                    是否回传安卓id：${_data.isAndroidIdPassBack === 1 ? '是' : '否'}
                    是否回传Mac：${_data.isMacPassBack === 1 ? '是' : '否'}
                    是否回传oaId：${_data.isOaIdPassBack === 1 ? '是' : '否'}
                    素材格式预警：${_data.materialFormatWarning}
                    检测公司：${_data.monitorNames}
                    任务组：${_data.creatorGroupId}
                    责任人：${_data.principal}
                `;
        return dom;
    };
    renderJsxDetail = data => {
        const _data = JSON.parse(data);
        // console.log('第一条数据', _data);
        return (
            <div>
                <div className="taskDetail" style={{padding: '20px'}}>
                    <Row className="margin-10">
                        <Col span={6}>订单名称：</Col>
                        <Col span={18}>{_data.taskDescription}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>任务名称：</Col>
                        <Col span={18}>{_data.taskName}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>任务类型：</Col>
                        <Col span={18}>{_data.taskType}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>APP唤醒方式：</Col>
                        <Col span={18}>{_data.appWake || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>安卓ios分离：</Col>
                        <Col span={18}>{_data.iosAndroidIPSame || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>指定设备号前缀：</Col>
                        <Col span={18}>{_data.deviceRedisKeyPreFix || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>UA标识：</Col>
                        <Col span={18}>{_data.uaFlag || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>iOS设备库ID：</Col>
                        <Col span={18}>{_data.iosUaPathId || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>Android设备库ID：</Col>
                        <Col span={18}>{_data.androidUaPathId || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>苹果UA分布：</Col>
                        <Col span={18}>{_data.iosUaVersion || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>安卓UA分布：</Col>
                        <Col span={18}>{_data.androidUaVersion || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>任务来源：</Col>
                        <Col span={18}>{_data.taskSource}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>兴趣：</Col>
                        <Col span={18}>{_data.interest}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>用户信息：</Col>
                        <Col span={18}>{_data.userInfo}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>是否是外部任务：</Col>
                        <Col span={18}>{_data.isOutAd}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>app包名：</Col>
                        <Col span={18}>{_data.packageName}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>留存比例：</Col>
                        <Col span={18}>{_data.retainRatio}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>账号信息：</Col>
                        <Col span={18}>{_data.accountKey}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>设备Id利用次数：</Col>
                        <Col span={18}>{_data.deviceIdReusedTimes}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>设备Id利用次数限制范围：</Col>
                        <Col span={18}>{_data.deviceIdDiffByTaskOrEid}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>API：</Col>
                        <Col span={18}>{_data.api}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>API时间间隔：</Col>
                        <Col span={18}>{_data.evClickIntervalTime}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>素材是否使用真实ip: </Col>
                        <Col span={18}>{_data.isApiMaterialUseRealIp == 1 ? '是' : '否'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>设备类型：</Col>
                        <Col span={18}>{_data.deviceInfo}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>线索信息：</Col>
                        <Col span={18}>{_data.clue}</Col>
                    </Row>

                    <Row className="margin-10">
                        <Col span={6}>安卓占比：</Col>
                        <Col span={18}>{_data.androidRatio}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>平台：</Col>
                        <Col span={18}>{_data.platform}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>曲线基准：</Col>
                        <Col span={18}>{_data.curve}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>结束方式：</Col>
                        <Col span={18}>{_data.endType}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>url：</Col>
                        <Col span={18}>{_data.url}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>强制到达：</Col>
                        <Col span={18}>{_data.forceArrive}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>是否S2S：</Col>
                        <Col span={18}>{_data.isS2S}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>指定代理商：</Col>
                        <Col span={18}>{_data.appointProxyName}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>排除代理商：</Col>
                        <Col span={18}>{_data.excludeProxyName}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>独享代理池：</Col>
                        <Col span={18}>{_data.exclusiveProxy}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>总量控制：</Col>
                        <Col span={18}>{_data.tc == 0 ? '是' : '否'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>忽略阻塞限制：</Col>
                        <Col span={18}>{_data.ignoreThreshold == 0 ? '关闭' : '开启'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>分配方式：</Col>
                        <Col span={18}>{_data.onTargetPv == 0 ? '余量分配' : '总量分配'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>禁用图片：</Col>
                        <Col span={18}>{_data.disableImg == 0 ? '关闭' : '开启'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>是否打码：</Col>
                        <Col span={18}>{_data.needHitCode == 0 ? '否' : '是'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>是否接码：</Col>
                        <Col span={18}>{_data.needReceiveCode == 0 ? '否' : '是'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>代理模式：</Col>
                        <Col
                            span={18}>{_data.proxyModel == undefined ? '' : (_data.proxyModel == 0 ? 'VPN' : 'SYSPOXY')}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>外部任务分类：</Col>
                        <Col span={18}>{_data.outType}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>目标量：</Col>
                        <Col span={18}>{_data.targetPv}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>溢出量：</Col>
                        <Col span={18}>{_data.overflowRate}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>自定义溢出比例：</Col>
                        <Col span={18}>{_data.overflow}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>期望溢出：</Col>
                        <Col span={18}>{_data.expectOverFlow}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>ivt阈值：</Col>
                        <Col span={18}>{_data.ivt}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>启用截图：</Col>
                        <Col span={18}>{_data.screenshots == 0 ? '关闭' : '开启'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>省份：</Col>
                        <Col span={18}>{_data.provinces}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>所属集群：</Col>
                        <Col span={18}>{_data.belongCluster}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>启用时间：</Col>
                        <Col span={18}>{_data.filtration}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>时间段：</Col>
                        <Col span={18}>{JSON.stringify(_data.timePairs)}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>等待时长(S)：</Col>
                        <Col span={18}>{_data.waitTimeout}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>代理有效时长：</Col>
                        <Col span={18}>{_data.forceWait}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>UV占比：</Col>
                        <Col span={18}>{_data.pvToUvRatio}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>利用次数：</Col>
                        <Col span={18}>{_data.ipReusedTimes}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>利用次数限制范围：</Col>
                        <Col span={18}>{_data.ipDiffByTaskOrEid}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>ip使用范围：</Col>
                        <Col span={18}>{_data.ipRange}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>ip利用次数单位时间：</Col>
                        <Col span={18}>{_data.ipInterval}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>单位时间ip利用次数：</Col>
                        <Col span={18}>{_data.ipUnitReuseTimes}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>引擎：</Col>
                        <Col span={18}>{_data.engine}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>主脚本地址：</Col>
                        <Col span={18}>{_data.mainScriptPath}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>脚本地址：</Col>
                        <Col span={18}>{_data.scriptPath}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>客户端分组id：</Col>
                        <Col span={18}>{_data.groupId || ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>异步请求：</Col>
                        <Col span={18}>{_data.isAsynRequest == 1 ? '是' : '否'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>强制互动：</Col>
                        <Col span={18}>{_data.forceInteraction == 0 ? '关闭' : '开启'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>检测公司预警：</Col>
                        <Col span={18}>{_data.interactionAlarm == 0 ? '关闭' : '开启'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>自动修改溢出：</Col>
                        <Col span={18}>{_data.autoUpdateOverFlowRate == 0 ? '关闭' : '开启'}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>执行脚本：</Col>
                        <Col span={18}>{_data.executeScript}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>脚本互动比例：</Col>
                        <Col span={18}>{_data.shellProportion}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>referer：</Col>
                        <Col span={18}>{_data.referer}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>完成标记：</Col>
                        <Col span={18}>{_data.finishedFlag}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>请求类型：</Col>
                        <Col span={18}>{_data.requestType}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>行为数据：</Col>
                        <Col span={18}>{_data.behaviourData}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>行为互动比例：</Col>
                        <Col span={18}>{_data.activeProportion}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>互动执行延时：</Col>
                        <Col span={18}>{_data.behaviourDataWaitTime}</Col>
                    </Row>
                    {/*  <Row className="margin-10">
                        <Col span={6}>随机溢出：</Col>
                        <Col span={18}>{_data.randomOverFlowRate}</Col>
                    </Row>*/}
                    <Row className="margin-10">
                        <Col span={6}>附加信息：</Col>
                        <Col span={18}>{_data.dependentType}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>素材格式预警：</Col>
                        <Col span={18}>{_data.materialFormatWarning}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>监测代码请求期望数：</Col>
                        <Col span={18}>{_data.irCountExcept || 0}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>关联taskId：</Col>
                        <Col span={18}>{_data.connectTaskIds}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>执行速度系数：</Col>
                        <Col span={18}>{_data.speedRatio}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>追踪取样比例: </Col>
                        <Col span={18}>{_data.trackingSamplingRatio}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>取样结束时间: </Col>
                        <Col
                            span={18}>{_data.trackingFinishTime != null && _data.trackingFinishTime != undefined ? (new Date(parseInt(_data.trackingFinishTime)).toLocaleString().replace(/:\d{1,2}$/, ' ')) : ''}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>点击率：</Col>
                        <Col span={18}>{_data.clickRate}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>点击率分组：</Col>
                        <Col span={18}>{_data.clickRateFlag}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>任务关联关键字：</Col>
                        <Col span={18}>{_data.connectKey}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>到达率：</Col>
                        <Col span={18}>{_data.hzArrivalRate}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>检测公司：</Col>
                        <Col span={18}>{_data.monitorNames}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>任务组：</Col>
                        <Col span={18}>{_data.creatorGroupId}</Col>
                    </Row>
                    <Row className="margin-10">
                        <Col span={6}>责任人：</Col>
                        <Col span={18}>{_data.principal}</Col>
                    </Row>
                    {/* <Row className="margin-10">*/}
                    {/* <Col span={6}>行为数据：</Col>*/}
                    {/* <Col span={18}>{_data.behaviourData}</Col>*/}
                    {/* </Row>*/}
                </div>
            </div>
        );
    };


    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    }

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    }

    render() {
        const {list, oldData} = this.props;
        let _this = this;
        if (_this.state.lastIndex > 1) {
            return (<div>
                <Timeline>
                    {list.map(item => {
                        switch (item.type) {
                            case 1:
                                return (
                                    <Timeline.Item>{item.operationName} {item.createTime} 创建了任务 <Button onClick={() => {
                                        this.showDetailModal(item);
                                    }}>查看详情</Button></Timeline.Item>);
                                break;
                            case 2:
                                return (
                                    <Timeline.Item>{item.operationName} {item.createTime} 更新了任务 <Button onClick={() => {
                                        this.showDetailModal(item);
                                    }}>查看详情</Button></Timeline.Item>);
                                break;
                            case 3:
                                return (<Timeline.Item>{item.operationName} {item.createTime} 删除了任务</Timeline.Item>);
                                break;
                            case 4:
                                return (<Timeline.Item>{item.operationName} {item.createTime} 上线了任务</Timeline.Item>);
                                break;
                            case 5:
                                return (<Timeline.Item>{item.operationName} {item.createTime} 下线了任务</Timeline.Item>);
                                break;
                        }
                    })
                    }
                </Timeline>

                {this.state.visible && <Modal
                    title="Basic Modal"
                    visible={this.state.visible}
                    width={900}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <Row>
                        <Col span={12} style={{paddingLeft: '5px'}}>
                            <h3>修改前</h3>
                        </Col>
                        <Col span={12} style={{paddingLeft: '5px'}}>
                            <h3>修改后</h3>
                        </Col>
                    </Row>
                    <div style={{background: '#fff', wordBreak: 'break-all'}} className="articleBox">
                        <Diff before={_this.renderDetail(oldData)} after={_this.renderDetail(newData)}></Diff>
                    </div>
                </Modal>}
            </div>);
        } else {
            return (<div>
                <Timeline>
                    {list.map(item => {
                        switch (item.type) {
                            case 1:
                                return (
                                    <Timeline.Item>{item.operationName} {item.createTime} 创建了任务 <Button onClick={() => {
                                        this.showDetailModal(item);
                                    }}>查看详情</Button></Timeline.Item>);
                                break;
                            case 2:
                                return (
                                    <Timeline.Item>{item.operationName} {item.createTime} 更新了任务 <Button onClick={() => {
                                        this.showDetailModal(item);
                                    }}>查看详情</Button></Timeline.Item>);
                                break;
                            case 3:
                                return (<Timeline.Item>{item.operationName} {item.createTime} 删除了任务</Timeline.Item>);
                                break;
                            case 4:
                                return (<Timeline.Item>{item.operationName} {item.createTime} 上线了任务</Timeline.Item>);
                                break;
                            case 5:
                                return (<Timeline.Item>{item.operationName} {item.createTime} 下线了任务</Timeline.Item>);
                                break;
                        }
                    })
                    }
                </Timeline>

                {this.state.visible && <Modal
                    title="Basic Modal"
                    visible={this.state.visible}
                    width={900}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    {this.renderJsxDetail(newData)}
                </Modal>}
            </div>);
        }
    }
}

const mapStateToProps = state => ({
    list: state.tasklist.tasklogs.list,
    oldData: state.tasklist.tasklogs.tasklogByIndex,
});
const mapDispatchToProps = dispatch => ({
    getTasklogs: () => dispatch(getTasklogs()),
    getTasklogByIndex: data => dispatch(getTasklogByIndex(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TaskTimeLineComponent));



// WEBPACK FOOTER //
// ./pages/task/tasklist/timeLineList.jsx